/**
 * 帮助中心列表页面路径
 */
export const HELP_DOC_LIST_PAGE_PATH = '/help/list'

/**
 * 帮助中心创建页面路径
 */
export const HELP_DOC_CREATE_PAGE_PATH = '/help/create'

/**
 * 帮助中心编辑页面路径
 */
export const HELP_DOC_EDIT_PAGE_PATH = '/help/edit'
